import React, {useEffect, useState} from "react";
const MovieApiClient = () => {
    const [movies, setMovies] = useState([]);
    // const [movie, setMovie] = useState({title: '', rating: 2.5});
    const [movie, setMovie] = useState({_id: (new Date().getTime().toString()), title: '', stars: 2.5});

    useEffect(() =>
            fetch('https://node-on-server.herokuapp.com/movies')
                .then(response => response.json())
                .then(movies => setMovies(movies))
        , []
    );

    const onMovieTitleChange = (event) =>
        setMovie
        (
            {...movie,
                title: event.target.value
            }
        );

    //     fetch(`http://localhost:4000/api/movies/${movie._id}`, {
    //     method: 'PUT',
    //     body: JSON.stringify(movie),
    //     headers: {
    //         'content-type': 'application/json'
    //     }
    // })
    //     .then(response => response.json())
    //     .then(movies => setMovies(movies));

    const createMovieClickHandler = () =>
        fetch('https://node-on-server.herokuapp.com/movies', {
            method: 'POST',
            body: JSON.stringify(movie),
            headers: {
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(movies => setMovies(movies));

    const deleteMovie = (movie) =>
        fetch(`https://node-on-server.herokuapp.com/movies/${movie._id}`, {
            method: 'DELETE'
        })
            .then(response => response.json())
            .then(movies => setMovies(movies));

    const saveMovie = () =>
        fetch(`https://node-on-server.herokuapp.com/movies/${movie._id}`, {
            method: 'PUT',
            body: JSON.stringify(movie),
            headers: {
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(movies => setMovies(movies));


    return(
        <div>
            <h2>Movies</h2>
            <ul className="list-group">
                        <li className="list-group-item">
                            <input className="form-control"
                                   value={movie.title}
                                   onChange={onMovieTitleChange}
                                   style={{width: "70%"}}/>

                            <button
                                onClick={createMovieClickHandler}
                                className="btn btn-success ms-2 float-end">
                                Create
                            </button>
                            <button
                                onClick={saveMovie}
                                className="btn btn-primary ms-2 float-end">
                              Save
                            </button>
                        </li>
                {
                    movies.map((movie) =>
                        <li className="list-group-item"
                            key={movie._id}>
                            {movie.title} {movie.stars}

                            <button onClick={() => setMovie(movie)}
                                    className="btn btn-primary float-end ms-2">
                                Edit
                            </button>

                            <button onClick={() => deleteMovie(movie)}
                                    className="btn btn-danger float-end">
                                Delete
                            </button>
                        </li>
                    )
                }

            </ul>
        </div>
    )
};
export default MovieApiClient;

